export const sliderItems = [
  {
    id: 1,
    img: "https://i.ibb.co/XsdmR2c/1.png",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd"
  },
  {
    id: 2,
    img: "https://i.ibb.co/DG69bQ4/2.png",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed"
  },
  {
    id: 3,
    img: "https://i.ibb.co/cXFnLLV/3.png",
    title: "LOUNGEWEAR LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4"
  }
];

export const categories = [
  {
    id: 1,
    img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/15561680/2021/9/22/ae87dd98-3d80-449b-bf62-3834797d9a561632315919781DIVYANKWomenNavyBlueEthnicMotifsPrintedRegularMirrorWorkKurt1.jpg",
    title: "Kurta Sets",
    cat: "women"
  },
  {
    id: 2,
    img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/15243952/2021/8/24/4be7996b-bd4e-4c4f-ae3b-52ab0025f54d1629818437158SutaWomenBlue1.jpg",
    title: "Sarees",
    cat: "coat"
  },
  {
    id: 3,
    img: "https://media.kreeva.com/catalog/product/cache/7c33e366a4697170fe16efe27689b88e/3/5/3502_1_1.jpg",
    title: "Lehangas",
    cat: "jeans"
  }
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png"
  },
  {
    id: 2,
    img: "https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388"
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png"
  },
  {
    id: 4,
    img: "https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png"
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png"
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png"
  },
  {
    id: 7,
    img: "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1625592244-ch-shirt-dress-copy-1625592162.jpg?crop=0.8948545861297539xw:1xh;center,top&resize=480:*"
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png"
  }
];

export const homePageProductListings = [
  {
    id: 0,
    listTitle: "TRENDING IN INDIAN WEAR",
    products: [
      {
        id: 0,
        title: "All white Indian Wears",
        desc: "For an always cool outlook",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2513024/2018/2/22/11519290243301-Sojanya-Since-1958-White-Mens-100-Cotton-Chicken-Kurta-8591519290243101-1.jpg"
      },
      {
        id: 1,
        title: "Ethnic Casuals",
        desc: "Indians surely know the route to comfort",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2019/12/25/23a81493-18b9-4989-ad24-7a101e3b99c21577223690325-1.jpg"
      },
      {
        id: 2,
        title: "Printed kurta Sets",
        desc: "Festive Wears that your family will love",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/3/6/91035266-7aee-4793-9ae3-2016f813d8521583453207312-1.jpg"
      },
      {
        id: 3,
        title: "Everyday Kurtas",
        desc: "Festive Wears that your family will love",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1843247/2020/3/23/dda555f2-a714-4730-ad0e-46dd4443390c1584970279237ManyavarMenPurpleWovenStraightKurta1.jpg"
      },
      {
        id: 4,
        title: "Handpicked Trendy Styles",
        desc: "Update the language of comfort",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/5/6/d4fd33be-ff6e-4fd4-a82d-381c817f274f1620277580488-1.jpg"
      },
      {
        id: 5,
        title: "All white Indian Wears",
        desc: "For an always cool outlook",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2513024/2018/2/22/11519290243301-Sojanya-Since-1958-White-Mens-100-Cotton-Chicken-Kurta-8591519290243101-1.jpg"
      },
      {
        id: 6,
        title: "Ethnic Casuals",
        desc: "Indians surely know the route to comfort",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2019/12/25/23a81493-18b9-4989-ad24-7a101e3b99c21577223690325-1.jpg"
      },
      {
        id: 7,
        title: "Printed kurta Sets",
        desc: "Festive Wears that your family will love",
        img: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/3/6/91035266-7aee-4793-9ae3-2016f813d8521583453207312-1.jpg"
      }
    ]
  }
];
